import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Collapse,
} from '@mui/material';
import { Zap } from 'lucide-mui';
import { useLimits } from '../../../plan/hooks/limits';

const LimitReached: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const guardLimits = useLimits();

  useEffect(() => {
    const timer = setTimeout(() => {
      setExpanded(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleUpgradeClick = () => {
    guardLimits('templates', () => {});
  };

  return (
    <Collapse in={expanded}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        textAlign="center"
        py={2}
      >
        <Typography variant="h5" color="textPrimary" mt={2}>
          Template Limit Reached
        </Typography>
        <Typography variant="body1" color="textSecondary" mt={1}>
          You&apos;ve used all available AI credits for your current plan.
          Upgrade to continue.
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClickOpen}
            sx={{ mr: 2 }}
          >
            Learn More
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Zap />}
            onClick={handleUpgradeClick}
          >
            Upgrade
          </Button>
        </Box>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Why Can&apos;t I Use More Templates?</DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              Templates are pre-defined formats for analyzing and summarizing
              your video transcripts. They help you quickly extract specific
              information from your videos, such as key points from meetings,
              action items from project discussions, or insights from customer
              interviews.
            </Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>
              You&apos;ve reached the limit of templates your current plan
              allows. Upgrade to continue using templates and unlock more
              features.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" variant="outlined">
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Zap />}
              onClick={handleUpgradeClick}
            >
              Upgrade
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Collapse>
  );
};

export default LimitReached;
